import { useReactFlow, useStoreApi } from '@xyflow/react';
import { useCallback } from 'react';

import { StructureCanvasHelper } from '../canvas';
import type { Rect } from '../layout';

// Must be called inside <ReactFlowProvider>. Tabbing to something off screen pans it into view, as React Flow does for cards.
function useRevealOnFocus() {
  const rf = useReactFlow();
  const store = useStoreApi();

  return useCallback(
    (rect: Readonly<Rect>) => {
      const { transform, width, height } = store.getState();
      if (
        StructureCanvasHelper.isRectInView(rect, transform, { width, height })
      )
        return;
      rf.setCenter(rect.x + rect.width / 2, rect.y + rect.height / 2, {
        zoom: transform[2],
      });
    },
    [rf, store]
  );
}

export { useRevealOnFocus };
